module.exports = require("tether-tooltip");


//////////////////
// WEBPACK FOOTER
// external "tether-tooltip"
// module id = 2
// module chunks = 0